module.exports = __webpack_public_path__ + "static/media/gmail.62ae32d1.jpg";